<template>
  <div class="realTimeMonitoringList">
    <div class="filters">
      <el-form :inline="true">
        <!-- <el-form-item>
          <el-select v-model="gardenId">
            <el-option key :label="$t('lang.lab_chooseGarden')" value=""></el-option>
            <el-option v-for="(item,index) in gardens" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item>
          <el-cascader v-model="threeLevelVal" :options="threeLevelData" clearable :props="{ checkStrictly: true }"
            placeholder="请选择所在区域"></el-cascader>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="gardenName" placeholder="请输入所在小区"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="unitinnernum" placeholder="请输入安装位置"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="searchInput" v-model="registercode" placeholder="请输入电梯注册代码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="brand">
            <el-option label="请选择电梯品牌" value=""></el-option>
            <el-option v-for="(item,index) in brandList" :key="index" :label="item.name" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="adaptplace">
            <el-option label="请选择使用场所" value=""></el-option>
            <el-option label="住宅" value="住宅"></el-option>
            <el-option label="写字间" value="写字间"></el-option>
            <el-option label="商业" value="商业"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker v-model="installDate" type="daterange" value-format="timestamp" range-separator="至"
            start-placeholder="安装开始日期" end-placeholder="安装结束日期">
          </el-date-picker>
        </el-form-item>
        <el-button type="primary" @click="commit()">查询</el-button>
      </el-form>
    </div>
    <el-card>
      <el-table :data="tableData"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="100px">
        </el-table-column>
        <el-table-column prop="Registercode" label="电梯注册码" width="180">
        </el-table-column>
        <el-table-column prop="Adaptplace" label="使用场所">
        </el-table-column>
        <el-table-column prop="Place" label="安装位置" width="230">
        </el-table-column>
        <el-table-column prop="Brand" label="品牌">
        </el-table-column>
        <el-table-column prop="districtName" label="所在区域">
        </el-table-column>
        <el-table-column prop="Unitinnernum" label="所在楼宇">
        </el-table-column>
        <el-table-column prop="State" label="设备状态">
          <template slot-scope="scope">
            <span v-if="scope.row.State == 0" style="color:#67C23A;">在线</span>
            <span v-if="scope.row.State == 1">调试</span>
            <span v-if="scope.row.State == 2" style="color:red;">离线</span>
          </template>
        </el-table-column>
        <el-table-column prop="Usedate" label="投用时间" sortable>
        </el-table-column>
        <el-table-column prop="operation" label="实时监测" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="videoDetail(scope.row)">实时监测</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="监控设备" :width="require('@/config/enum').opr_width1">
          <el-image style="width: 25px;" src="https://oss.kmyhwy.cn/2025/03/20/e9ace752-b8ff-429c-b5b7-124a02e331f1.png"
            fit="cover"></el-image>
        </el-table-column>
        <el-table-column prop="operation" label="电梯画像" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="elevatorPortray(scope.row)">电梯画像</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="operation" label="操作" :width="require('@/config/enum').opr_width1">
          <template slot-scope="scope">
            <el-button @click="detail(scope.row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]" :page-size="pageSize" layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount" />
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:realTimeMonitoringList
   *@Description:电梯物联网实时监测列表
   *@author:杜斌
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // import { mapGetters } from 'vuex'

  export default {
    name: '/manage/main.realTimeMonitoringList',
    data() {
      return {
        gardens: [], // 园区列表
        tableData: [], // table列表数据
        gardenId: '', // 选择园区的id（模糊查询）
        gardenName: '', // 园区名称（模糊查询）
        cityId: '', // 城市id
        unitinnernum: '', // 安装位置
        registercode: '', // 注册代码
        brand: '', // 电梯品牌
        adaptplace: '', // 使用场所
        installDate: '', // 安装日期数组
        startTs: '', // 安装开始日期
        endTs: '', // 安装结束日期
        pageNo: 1, // 页数
        pageSize: 10, // 每页显示数量
        pageCount: 0, // 总页数
        brandList: [{
            name: '星玛',
            value: '星玛'
          },
          {
            name: '永大',
            value: '永大'
          },
          {
            name: '日立',
            value: '日立'
          },
          {
            name: '西子奥的斯',
            value: '西子奥的斯'
          },
          {
            name: '蒂森',
            value: '蒂森'
          },
          {
            name: '博林特',
            value: '博林特'
          },
          {
            name: '通力',
            value: '通力'
          },
          {
            name: '奥的斯',
            value: '奥的斯'
          },
          {
            name: '迅达',
            value: '迅达'
          },
          {
            name: '三菱',
            value: '三菱'
          },
          {
            name: '东芝',
            value: '东芝'
          },
        ], // 电梯品牌list
        threeLevelVal: [],
        threeLevelData: [], // 省市区三级联动数据
        threeId: '', // 三级id
        threeType: '3', // 三级type
      }
    },
    watch: {},
    created() {
      // this.selectGarden()
      this.getThreeLevel()
      this.getData()
    },
    methods: {
      // 获取小区下拉
      selectGarden() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.gardens = res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 格式化三级省市区联动数据
      rewriteKey(val) {
        val.forEach(item => {
          item.label = item.name
          item.value = item.id
          if (item.children.length > 0) {
            this.rewriteKey(item.children)
          } else {
            delete item.children
          }
        })
      },
      // 获取三级省市区联动数据
      getThreeLevel() {
        this.$get(
          `aapi/liftMonitorThreeLevel`
        ).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.threeLevelData = res.list
              this.rewriteKey(this.threeLevelData)
              let obj = {
                label: '全部',
                name: '',
                parentId: '',
                type: 1,
                value: '',
              }
              this.threeLevelData.unshift(obj)
              console.log(this.threeLevelData)
            }
          },
          error => {
            this.$message.error(error)
          })
      },
      // 获取列表数据
      getData() {
        if (this.threeLevelVal.length == 1) {
          this.threeId = this.threeLevelVal[0]
          this.threeType = 1
        } else if (this.threeLevelVal.length == 2) {
          this.threeId = this.threeLevelVal[1]
          this.threeType = 2
        } else if (this.threeLevelVal.length == 3) {
          this.threeId = this.threeLevelVal[2]
          this.threeType = 3
        } else {
          this.threeId = ''
          this.threeType = ''
        }
        if (this.installDate != null && this.installDate.length > 0 && this.installDate != '') {
          this.startTs = this.installDate[0]
          this.endTs = this.installDate[1]
        } else {
          this.startTs = ''
          this.endTs = ''
        }
        let loading = this.$loading()
        this.$get(
          `aapi/liftMonitor?threeId=${this.threeId}&threeType=${this.threeType}&gardenId=${this.gardenId}&cityId=${this.cityId}&unitinnernum=${this.unitinnernum}&registercode=${this.registercode}&brand=${this.brand}&adaptplace=${this.adaptplace}&startTs=${this.startTs}&endTs=${this.endTs}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
        ).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              console.log(res)
              this.tableData = res.list
              this.pageCount = res.pageCount
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          })
      },
      // 实时监测详情
      videoDetail(rowData) {
        this.$router.push({
          name: 'realTimeMonitoringDetail',
          query: {
            object: rowData
          }
        })
      },
      // 电梯画像
      elevatorPortray(rowData) {
        this.$router.push({
          name: 'elevatorPortray',
          query: {
            object: rowData
          }
        })
      },
      // 电梯详情
      detail(rowData) {
        this.$router.push({
          name: 'elevatorDetail',
          query: {
            object: rowData
          }
        })
      },
      // 更新
      commit() {
        this.pageNo = 1
        this.getData()
      },
      // 翻页
      handleCurrentChange(val) {
        this.pageNo = val
        this.getData()
      },
      // 切换每页显示多少数据
      handleSizeChange(val) {
        this.pageNo = 1
        this.pageSize = val
        this.getData()
      },
      // 表格斑马
      tableRowClassName({
        row,
        rowIndex
      }) {
        return rowIndex % 2 === 0 ? 'row-dark' : ''
      },
      // 多选框
      handleSelectionChange(val) {
        this.multipleSelection = val
      },
      // ID序号功能
      indexMethod(index) {
        return (this.pageNo - 1) * this.pageSize + index + 1
      },
    }
  }
</script>

<style lang="scss">
  .realTimeMonitoringList {
    .el-cascader {
      line-height: 32px;
    }
  }
</style>